// Live weather for the dateline.
//
// Hits Open-Meteo (free, no API key, CORS-enabled) for current
// wind and temperature at Brunswick Heads. Caches for 30 min in
// localStorage so repeated visits don't re-hit the API.
//
// On failure or offline, the template's hardcoded fallback text
// remains visible — the user never sees an empty / errored state.

const LAT = -28.543;
const LON = 153.553;

const CACHE_KEY = "gg-weather-v1";
const CACHE_TTL_MS = 30 * 60 * 1000;

const API_URL =
    `https://api.open-meteo.com/v1/forecast` +
    `?latitude=${LAT}` +
    `&longitude=${LON}` +
    `&current=temperature_2m,wind_speed_10m,wind_direction_10m` +
    `&wind_speed_unit=kn` +
    `&temperature_unit=celsius` +
    `&timezone=Australia%2FSydney`;

// Meteorological convention: wind "from" direction. 0° = from north.
const DIRECTIONS = [
    "Northerly",        // 0
    "North-easterly",   // 45
    "Easterly",         // 90
    "South-easterly",   // 135
    "Southerly",        // 180
    "South-westerly",   // 225
    "Westerly",         // 270
    "North-westerly"    // 315
];

function degreesToDirection(deg) {
    const idx = Math.round(deg / 45) % 8;
    return DIRECTIONS[idx];
}

function format({ windDir, windSpeed, temp }) {
    const dir = degreesToDirection(windDir);
    const kt = Math.round(windSpeed);
    const c = Math.round(temp);
    return `${dir} ${kt} kt, ${c}\u00B0C`;
}

function readCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
        return parsed.text;
    } catch {
        return null;
    }
}

function writeCache(text) {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ text, ts: Date.now() }));
    } catch {
        // storage full or disabled — non-fatal
    }
}

export default async function weather() {
    const el = document.querySelector("[data-weather]");
    if (!el) return;

    // Cache hit → paint and exit
    const cached = readCache();
    if (cached) {
        el.textContent = cached;
        return;
    }

    try {
        const res = await fetch(API_URL, { headers: { Accept: "application/json" } });
        if (!res.ok) return;

        const data = await res.json();
        const current = data && data.current;
        if (!current) return;

        const text = format({
            windDir: current.wind_direction_10m,
            windSpeed: current.wind_speed_10m,
            temp: current.temperature_2m
        });

        el.textContent = text;
        writeCache(text);
    } catch {
        // Offline, blocked, or API down — leave the template fallback as-is
    }
}
